/**
 * Main Menu (Screen 1) — v0M3.7 + v0M15.3 + v0M15.4.
 *
 * Five buttons per Michael's spec:
 *   1. New Game    → 'mode' screen
 *   2. Load Game   → slot picker (v0M15.3 — was banner placeholder)
 *   3. Multiplayer (placeholder — banner)
 *   4. Settings    → Settings modal (v0M15.4 — was banner placeholder)
 *   5. Exit        → window.close() + reload fallback
 */

import type { MenuState } from './menu-state';

export interface MainMenuCallbacks {
  onNewGame: () => void;
  onLoadGame: () => void;
  onSettings: () => void;
  onComingSoon: (label: string) => void;
  onExit: () => void;
}

export function renderMainMenu(
  panel: HTMLElement,
  state: MenuState,
  cb: MainMenuCallbacks,
): void {
  const h = document.createElement('h1');
  h.className = 'su-menu-title';
  h.textContent = 'Strategos Universalis';
  panel.appendChild(h);

  const sub = document.createElement('p');
  sub.className = 'su-menu-subtitle';
  sub.textContent = 'Ancient Empires';
  panel.appendChild(sub);

  if (state.banner !== null) {
    const banner = document.createElement('div');
    banner.className = 'su-menu-banner';
    banner.textContent = state.banner;
    panel.appendChild(banner);
  }

  panel.appendChild(makeButton('New Game', cb.onNewGame));
  panel.appendChild(makeButton('Load Game', cb.onLoadGame));
  panel.appendChild(makeDisabledButton('Multiplayer', () => cb.onComingSoon('Multiplayer')));
  panel.appendChild(makeButton('Settings', cb.onSettings));
  panel.appendChild(makeButton('Exit', cb.onExit));
}

function makeButton(label: string, onClick: () => void): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.className = 'su-menu-button';
  btn.textContent = label;
  btn.addEventListener('click', onClick);
  return btn;
}

function makeDisabledButton(label: string, onClick: () => void): HTMLButtonElement {
  const btn = makeButton(label, onClick);
  btn.classList.add('su-disabled');
  return btn;
}
